import { createPerimeter } from 'vue-kindergarten';
import { isLoggedIn } from '../utilities/roleUtilities';

export const LoginPerimeter = createPerimeter({
    purpose: 'prices',

    can: {
        read () {
            return !isLoggedIn(this.child);
        }
    }
});
